export type TranslationType = {
  locale: string;
  name: string;
  description: string;
};

export interface CustomBundle {
  id: string;
  ticker: string;
  active: boolean;
  inventoryLinesList: string[];
  extrasList: string[];
  promotionsList: string[];
  codesList: string[];
  travelWindowsList: RangeDateWindowsType[];
  translationsList: TranslationType[];
  bundlePriceType: string;
  multimediaList: any;
  bundlePrice: number;
  restrictions: BundleRestrictions;
}

export interface BundleRestrictions {
  minStayType?: BundleRestrictionType;
  minStay?: number;
  maxStayType?: BundleRestrictionType;
  maxStay?: number;
  minNoticeType?: BundleRestrictionType;
  minNotice?: number;
  maxNoticeType?: BundleRestrictionType;
  maxNotice?: number;
  closeToArrivalType?: BundleRestrictionType;
  closeToDepartureType?: BundleRestrictionType;
}

export enum BundleRestrictionType {
  CONSTANT = "CONSTANT",
  OWN = "OWN",
  NONE = "NONE",
}

export enum WEEK_DAYS {
  MONDAY = 0,
  TUESDAY = 1,
  WEDNESDAY = 2,
  THURSDAY = 3,
  FRIDAY = 4,
  SATURDAY = 5,
  SUNDAY = 6,
}

export type RangeDateWindowsType = {
  id: string;
  startDate: string | null;
  endDate: string | null;
  weekDays: string[];
};

export type RangeDateWindowsGRPCType = {
  startDate: string | null;
  endDate: string | null;
  weekDaysList: number[];
};

export enum CRUD_MODE {
  EDIT,
  ADD,
}

export enum BundlePriceType {
  BUNDLE_TYPE_FIXED = 0,
  BUNDLE_TYPE_DYNAMIC = 1,
  BUNDLE_TYPE_OWN = 2,
}

export type FormType = {
  ticker: string;
  active: boolean;
  codesList: string;
  bundlePriceType: string;
  extrasList: string[];
  promotionsList: string[];
  inventoryLinesList: string[];
  translationsList: TranslationType[];
  bundlePrice: number;
  restrictions: BundleRestrictions;
};

export type MultimediaTranslationType = {
  [key: string]: {
    title: string;
    description: string;
  };
};

export type MultiMediaType = {
  id: string;
  filename: string;
  url: string;
  translations: MultimediaTranslationType;
};

//Theses values are not included in react-hook-forms
export type OtherValuesType = {
  id: string;
  travelWindows: RangeDateWindowsType[];
  multimediaList: any[];
};
